angular.module('bb.listing_view').config(ListingViewRoutes);

ListingViewRoutes.$inject = ['$routeProvider'];
function ListingViewRoutes($routeProvider) {
  $routeProvider.when('/listing/:listingId/view', {
    template: '<listing-view-internal />',
  });
}

export {};
